import { Dataset, Dimension, Match, Model } from '@hub-components';

export interface DataSlicersViewData {
  pageId: number;
  dataSlicers: DataSliceViewer[];
}

export class DataSliceEditor extends Model {
  public page: number;
  public dashboardId: number;
  public dataset: string;
  public dimension: string;

  constructor(obj: any) {
    super(obj);
    this.id = obj.id;
    this.page = obj.page;
    this.dataset = obj.dataset;
    this.dimension = obj.dimension;
  }

  asJson() {
    return {
      id: this.id,
      page: this.page,
      dataset: this.dataset,
      dimension: this.dimension,
      _destroy: this._destroy,
    };
  }
}

export class DataSliceViewer extends Model {
  public page: number;
  public dashboardId: number;
  public dataset: Dataset;
  public dimension: Dimension;
  public matches?: Match[];
  public title?: string;
  public loading?: boolean;

  constructor(obj: any) {
    super(obj);
    this.page = obj.page;
    this.dataset = obj.dataset;
    this.dimension = obj.dimension;
    this.matches = obj.matches;
    this.title = obj.title;
  }
}
